import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { errorPage } from "../images";

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="sm:pt-[30px] py-6 container space-y-5 min-h-[calc(100dvh-74px)] flex flex-col">
      <div className="flex justify-center items-center flex-auto">
        <div className="w-full">
          <img src={errorPage} alt="errorPage" className="mx-auto px-5" />
          <div className="grid gap-y-10">
            <div>
              <h2 className="sm:text-[32px] text-2xl text-center font-semibold text-gray-700 mb-5">
                Oops! Page not found!
              </h2>
              <p className="sm:text-2xl text-lg text-center text-gray-800">
                This is not the page you are looking for
              </p>
            </div>
            <Button
              variant="blue"
              onClick={() => navigate(`/contracts`)}
              btnClassName="mx-auto"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
